var i = /* @__PURE__ */ ((r) => (r.Base = "iress-u-inline", r.NoWrap = "iress--no-wrap", r.HorizontalAlign = "iress--h-align", r.VerticalAlign = "iress--v-align", r.Gutter = "iress--gutter", r))(i || {});
export {
  i as InlineCssClass
};
